/**
 *
 */
export enum SortConversationsBy {
  Recommended = 0,
  MostRecent = 1,
  HighToLow = 2,
  LowToHigh = 3,
}
